import { axiosAPI as axios, responseHandler } from 'utils';
import { isOnline } from 'mobile-modules/offline';
import {
  cacheFamilySession,
  getCachedFamilySession,
} from 'mobile-modules/offline/cache';
import { buildOfflineFamilyLogin, rememberOnlineFamilyLogin } from 'mobile-modules/offline/auth';

export default {
  // Registration remains online-only. LC/product/purchase/configuration continue
  // to come from the existing server flow exactly as before.
  getRegistrationCountries() {
    return responseHandler(axios.get('api/config/mobile-registration-countries'));
  },
  getRegistrationOptions(params = {}) {
    return responseHandler(axios.get('api/mobile-wrapper/registration-options', { params }));
  },
  sendOtp(values) {
    return responseHandler(axios.post('api/mobile-wrapper/auth/send-otp', values));
  },
  verifyOtp(values) {
    return responseHandler(axios.post('api/mobile-wrapper/auth/verify-otp', values));
  },
  signInWithApple(values) {
    return responseHandler(axios.post('api/mobile-wrapper/auth/apple', values));
  },
  register(values) {
    return responseHandler(axios.post('api/mobile-wrapper/register', values));
  },

  // After one successful online registration/login, the family/member data is
  // cached and the same login can be restored offline on this device.
  async getFamilySession(familyAccountToken, tapDiagnostic = null) {
    if (!isOnline()) {
      return (await getCachedFamilySession()) || {
        success: false,
        offline: true,
        error: 'Connect to the internet once to prepare this family for offline use.',
      };
    }

    const result = await responseHandler(axios.post('api/mobile-wrapper/family-session', {
      familyAccountToken,
      ...(tapDiagnostic ? { tapDiagnostic } : {}),
    }));
    if (result?.success !== false && Array.isArray(result?.members)) await cacheFamilySession(result);
    return result;
  },

  async checkConfigChanged(revision) {
    if (!isOnline()) return false;
    const response = await axios.get('api/mobile-login-parent-tip/config-changed', {
      params: {
        revision: revision || undefined,
        _: Date.now(),
      },
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
    });

    return response.status === 200;
  },

  async loginFamilyMembers(values) {
    const usernames = Array.isArray(values?.usernames)
      ? values.usernames.filter(Boolean)
      : [values?.username, values?.username2].filter(Boolean);

    if (!isOnline()) return buildOfflineFamilyLogin(usernames);

    const result = await responseHandler(axios.post('api/mobile-wrapper/family-session/login', values));
    if (result?.token) await rememberOnlineFamilyLogin(result, usernames);
    return result;
  },
};
